import { apiFetch, apiAction } from 'utils';
import * as constants from '../constants/index';
import emailSnippet from '../schemas/emailSnippet';

export const loadSchedulingEmailSnippet = (calendar, snippet) => (
  //startAction, successAction, failureAction, actionPromise, params, schema
  apiAction(constants.BEGIN_LOADING_SCHEDULING_EMAIL_SNIPPET, constants.SUCCESS_LOADING_SCHEDULING_EMAIL_SNIPPET, constants.ERROR_LOADING_SCHEDULING_EMAIL_SNIPPET,
    (state) => apiFetch.get(state, `calendars/${calendar.id}/${calendar.emailType}_email_template`),
    {},
    {scheduling_email_snippet: emailSnippet}
  )
);

export const saveSchedulingEmailSnippet = (calendar, snippet) => (
  apiAction(constants.BEGIN_SAVING_SCHEDULING_EMAIL_SNIPPET, constants.SUCCESS_SAVING_SCHEDULING_EMAIL_SNIPPET, constants.ERROR_SAVING_SCHEDULING_EMAIL_SNIPPET,
    (state) =>
      apiFetch.put(
        state,
        `calendars/${calendar.id}/${calendar.emailType}_email_template`,
        {scheduling_email_snippet: snippet}
      ),
    {},
    {scheduling_email_snippet: emailSnippet}
  )
);
